export default __webpack_public_path__ + "static/media/fa_quote-left.8906fa51.svg";